import { StateCreator } from "zustand";
import { RemoteDeactivateCustomers } from "../../data/usecases/remove-deactivate-customers";
import { AxiosHttpClient } from "../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY,} from "../../base";
import Endpoints from "../../domain/endpoints";
import { FailedCustomerData } from "../../domain/models/failed-customer-data";
import { DeactivateCustomersType } from "../../domain/models/customer-database/deactivate-customers-type";
import Swal from "sweetalert2";
import { getDataKeyFromLocalStorage } from "../../common/utils/AuthToken";

export interface DeactivateCustomersInterface {
  deactivateCustomer: Function;
  progressCount: number;
  setProgressCount: Function;
  title: string;
  setTitle: Function;
  failedDeactivates: FailedCustomerData[];
  clearFailedDeactivates: Function;
  handleDeactivateLoading: Function;
}

const initialStates = {
  progressCount: 20,
  title: "",
  failedDeactivates: [],
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useDeactivateCustomer: StateCreator<
  DeactivateCustomersInterface
> = (set, get) => ({
  ...initialStates,
  deactivateCustomer: async (
    customer_info: DeactivateCustomersType,
    index: number,
    loading: boolean
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteDeactivateCustomers = new RemoteDeactivateCustomers(
      `${BASE_URL}${Endpoints.DEACTIVATE_CUSTOMERS}`,
      axiosHttpClient
    );
    get().handleDeactivateLoading(loading);
    let result = await remoteDeactivateCustomers.remove({ customer_info });
    if (result.success) {
      return result;
    } else {
      let payload = [
        ...get().failedDeactivates,
        {
          id: index,
          reason: result?.errors?.message
            ? result.errors.message
            : result.message,
        },
      ];

      set(() => ({
        failedDeactivates: payload,
      }));
      return result;
    }
  },
  setProgressCount: (index: number) => {
    set(() => ({ progressCount: index }));
  },
  setTitle: (userTitle: string) => {
    set(() => ({ title: userTitle }));
  },
  clearFailedDeactivates: () => {
    set(() => ({ failedDeactivates: [] }));
  },
  handleDeactivateLoading: (value: boolean) => {
    if (value) {
      Swal.fire({
        didOpen: () => {
          if (value) {
            Swal.showLoading();
          }
        },

        title: "Please wait... Customer deactivate request is sending ",
        customClass: {
          container: "swal2-style",
        },
      });
    }
  },
});
